<div class="backdrop"></div>
<div class="alert-box">
  <p>{{ message }}</p>
</div>
